// Command declarations (04 §4.1). Separate from command.ts so each phase's command files can
// declare commands without importing the registry.
import type { z } from 'zod';
import type { Permission, PrincipalKind } from '@ecobox/domain';

/** A command type's declaration. Every handler is registered with one of these. */
export interface CommandDefinition<P extends z.ZodType = z.ZodType> {
  type: string;
  /** The one staff permission this command requires (07 §7.2). */
  permission: Permission;
  /** Other permissions that also allow it: the person needs `permission` or any of these (04 §4.5). */
  alsoPermitted?: readonly Permission[];
  /** Non-staff principals that may issue it through a server function. */
  principals: readonly Exclude<PrincipalKind, 'staff'>[];
  /** Can be created offline and synced later (04 offline column). */
  offline: boolean;
  /** Only available in local and staging environments. */
  devOnly?: boolean;
  payload: P;
}

export function defineCommand<P extends z.ZodType>(
  def: CommandDefinition<P>,
): CommandDefinition<P> {
  return def;
}
